// Currency formatting utility for Open Finance components
export const formatCurrency = (value, options = {}) => {
  const {
    currency = 'BRL',
    locale = 'pt-BR',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = options;

  if (value === null || value === undefined || isNaN(value)) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(0);
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Number(value));
};

// Alternative export for backward compatibility
export const formatToBRL = (value) => formatCurrency(value);

// Format percentage
export const formatPercentage = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0%';
  }
  return `${Number(value).toFixed(decimals)}%`;
};

// Format large numbers with K, M, B suffixes
export const formatCompactCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return formatCurrency(0);
  }

  const absValue = Math.abs(value);
  
  if (absValue >= 1000000000) {
    return formatCurrency(value / 1000000000) + 'B';
  } else if (absValue >= 1000000) {
    return formatCurrency(value / 1000000) + 'M';
  } else if (absValue >= 1000) {
    return formatCurrency(value / 1000) + 'K';
  }
  
  return formatCurrency(value);
};
